<template>
    <div class="toast_wrap" :style="{ opacity: $GlobalStore.isShowToastVer2() ? 1 : 0, top: $GlobalStore.isShowToastVer2() ? '' : '100%' }">
        <!--<img v-if="$GlobalStore.toastVer2Type()" :src="require('@/assets/img/toast_x.png')" alt="" style="width: 13px; float: right; margin-top: 4px;" @click="close">-->
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
            <!--<div v-if="$GlobalStore.toastVer2Type()" style="width: 48px; height: 48px; background-color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center;">-->
                <!--<img :src="$GlobalStore.toastVer2Type()" alt="" style="width: 25px;">-->
            <!--</div>-->
            <div :class="$GlobalStore.toastVer2Type() ? 'default' : 'deletePost'" style="text-align:center;">{{$GlobalStore.toastStrVer2()}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "toastVer2",
    methods: {
        close() {
            this.$store.state.isShowToastVer2 = false
            this.$store.state.toastStrVer2 = ''
            this.$store.state.toastVer2Type = ''
        }
    },
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.toast_wrap {
    position: fixed;
    background: #210F03CC;
    color: white;
    bottom: 200px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 1s;
    padding: 20px 20px;
    border-radius: 15px;
    width: 80%;
}

.default {
    line-height: 16px;
    font-weight: 700;
    font-size: 14px;
}

.deletePost {
    margin: 0 auto;
    font-size: 14px;
    font-weight: 500;
    padding: 5px;
}
</style>